import { render, staticRenderFns } from "./constitution.vue?vue&type=template&id=73cc6e2a&scoped=true"
import script from "./constitution.vue?vue&type=script&lang=js"
export * from "./constitution.vue?vue&type=script&lang=js"
import style0 from "./constitution.vue?vue&type=style&index=0&id=73cc6e2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc6e2a",
  null
  
)

export default component.exports